export default __webpack_public_path__ + "static/media/parkingZone.6ddb82b6.svg";